const o = {
  postV1PromotionTemplatesKeyAssign: {
    schema: {
      method: "post",
      url: "/v1/promotion-templates/{key}/assign",
      mediaType: "application/json"
    }
  },
  postV1OwnerPromotionsIdCancel: {
    schema: {
      method: "post",
      url: "/v1/owner-promotions/{id}/cancel"
    }
  },
  postV1OwnerPromotionsIdForfeit: {
    schema: {
      method: "post",
      url: "/v1/owner-promotions/{id}/forfeit"
    }
  },
  getV1PromotionTemplates: {
    schema: {
      method: "get",
      url: "/v1/promotion-templates"
    }
  },
  postV1PromotionTemplates: {
    schema: {
      method: "post",
      url: "/v1/promotion-templates",
      mediaType: "application/vnd.api+json"
    }
  },
  getV1PromotionTemplatesId: {
    schema: {
      method: "get",
      url: "/v1/promotion-templates/{id}"
    }
  },
  patchV1PromotionTemplatesId: {
    schema: {
      method: "patch",
      url: "/v1/promotion-templates/{id}",
      mediaType: "application/vnd.api+json"
    }
  },
  deleteV1PromotionTemplatesId: {
    schema: {
      method: "delete",
      url: "/v1/promotion-templates/{id}"
    }
  },
  getV1OwnerPromotions: {
    schema: {
      method: "get",
      url: "/v1/owner-promotions"
    }
  },
  getV1OwnerPromotionsId: {
    schema: {
      method: "get",
      url: "/v1/owner-promotions/{id}"
    }
  }
};
export {
  o as v1Service
};
